module.exports = __webpack_public_path__ + "static/1-b1cf2761909bde627a81e912e2d4d4b0.jpg";